// extracted by mini-css-extract-plugin
export default {"searchInput":"personnelNumber_searchInput__6gCxT"};